// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2CLka","title":"Header_title__qssHj","left":"Header_left__3i9jp","clinicName":"Header_clinicName__3142A"};